import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/ui/views/HomeView.vue'
import TermsAndConditionsView from '@/ui/views/TermsAndConditionsView.vue'
import HelpView from '@/ui/views/HelpView.vue'
import GameView from '@/ui/views/GameView.vue'

const LobbyItemContent = () =>
  import(
    /* webpackChunkName: "lobby_item_content" */
    '@/ui/components/lobby/STLobbyItemContent.vue'
  )

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/ui/views/AboutView.vue')
    },
    {
      path: '/lobby/:id',
      name: 'LobbyItemContent',
      component: LobbyItemContent
    },
    {
      path: '/help',
      name: 'help',
      component: HelpView
    },
    {
      path: '/terms-and-conditions',
      name: 'termsAndConditions',
      component: TermsAndConditionsView
    },
    {
      path: '/games/:linkCode',
      name: 'game',
      component: GameView,
      props: true
    },
    {
      path: '/collections/:id',
      name: 'collection',
      component: () => import('@/ui/views/CollectionView.vue'),
      props: true
    }
  ]
})

export default router
